import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { basePath } from '../../Constants/constant';
import Dropdown from '../../Usables/Dropdown';
import InputField from '../../Usables/InputField';
import { CancelIcon, EditIcon, SaveIcon } from '../../Usables/IconButtons';
import CloseModal from '../../Usables/CloseModal';
import { AppContext } from '../../ContextApi/ContextApi';

function UserRegistration({data, disabled, onSubmit, OnlyView, onChange, loading, errors, onEdit, onCancel, onClose}) {
    const { apiHeaderJSON } = useContext(AppContext);
    const [allRoles, setAllRoles] = useState([]);
    const [allCompany, setAllCompany] = useState([]);

    const getRoleData = async () => {
        const response = await axios.get(`${basePath}/getroles`,{
            headers:apiHeaderJSON,
        });
        // console.log(response.data);
        if (response.status === 200) {
            let options = response?.data?.map((val)=>{
                return { value: val?.id, label: val?.role_name }
            })
            if(localStorage.getItem("role") !== "Super Admin"){
                options = response?.data?.filter((val)=>{
                    if(val?.role_name !== "Super Admin"){
                        return val;
                    }
                    return null;
                });
                options = options?.map((val)=>{
                    return { value: val?.id, label: val?.role_name };
                });
            }
            // console.log("options",options);
            setAllRoles(options);
        }
    }
    const getCompany = async () => {
            try {                
                const response = await axios.get(`${basePath}/getcompanybypage`,
                {
                    params: {
                        limit: 1000,
                        page: 1,
                        id: localStorage.getItem("userId"),
                    }
                });
                // console.log("company==>>", response);
                if(response?.status === 200){
                    const options = response?.data.data?.map((val)=>{
                        return {value: val?.id, label: val?.company_name}
                    })
                    setAllCompany(options);
                }
            } catch (error) {
                console.log(error);
            }
        }
    useEffect(() => {
        getRoleData();
        getCompany();
    }, []);


    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                {!OnlyView && 
                (onEdit && disabled && data?.id ? 
                <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                <>
                    {data?.id && <CancelIcon disabled={loading} className=" top-3 left-8" onClick={onCancel} />}
                    <SaveIcon disabled={loading} loading={loading} className={`${data?.id ? "top-3 left-36" : "top-3 left-3"}`} onClick={onSubmit} />
                </>)}
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>User Information</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 pb-2 max-h-[70vh] overflow-y-scroll'>
                    <div className='grid grid-cols-2 gap-3'>
                        <InputField
                        id="firstName"
                        name="firstName"
                        type="text"
                        label="First Name:"
                        placeholder="First Name"
                        value={data?.firstName}
                        onChange={onChange}
                        error={errors?.firstName}
                        disabled={disabled}
                        required
                        />
                        <InputField
                        id="lastName"
                        name="lastName"
                        type="text"
                        label="Last Name:"
                        placeholder="Last Name"
                        value={data?.lastName}
                        onChange={onChange}
                        error={errors?.lastName}
                        disabled={disabled}
                        required
                        />
                        <InputField
                        id="email"
                        name="email"
                        type="email"
                        label="Email:"
                        placeholder="Email"
                        value={data?.email}
                        onChange={onChange}
                        error={errors?.email}
                        disabled={disabled}
                        required
                        />
                        <InputField
                        id="phone"
                        name="phone"
                        type="text"
                        label="Mobile:"
                        placeholder="Phone"
                        value={data?.phone}
                        onChange={onChange}
                        error={errors?.phone}
                        disabled={disabled}
                        required
                        /> 
                        <InputField
                        id="designation"
                        name="designation"
                        type="text"
                        label="Designation:"
                        placeholder="Designation*"
                        value={data?.designation}
                        onChange={onChange}
                        error={errors?.designation}
                        disabled={disabled}
                        required
                        />
                        <Dropdown id="role_id" name="role_id"
                        onChange={onChange}
                        onCancel={onChange}
                        label="User Role:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`Select Role`}
                        value={data?.role_id}
                        options={allRoles}
                        error={errors?.role_id}
                        disabled={disabled}
                        required
                        />
                        {data?.role_id === 13 && (<Dropdown id="company_id" name="company_id"
                            onChange={onChange}
                            onCancel={onChange}
                            label="Company:"
                            className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                            placeholder={`Select Company`}
                            value={data?.company_id}
                            options={allCompany}
                            search={true}
                            error={errors?.company_id}
                            disabled={disabled}
                            required
                        />)}
                        <InputField
                        id="username_login"
                        name="username_login"
                        type="text"
                        label="Username:"
                        placeholder="Username"
                        value={data?.username_login}
                        onChange={onChange}
                        error={errors?.username_login}
                        disabled={disabled}
                        required
                        />
                        <InputField
                        id="password_login"
                        name="password_login"
                        type="text"
                        label="Password:"
                        placeholder="Password"
                        value={data?.password_login}
                        onChange={onChange}
                        error={errors?.password_login}
                        disabled={disabled}
                        required
                        />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UserRegistration;